var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sp2lnob-dashboard-app"},[_c('sp-2-lnob-topbar',{attrs:{"mode":_vm.mode,"input-params":_vm.params}}),_c('div',{staticClass:"row m-0"},[_c('div',{staticClass:"col-12 p-0"},[_c('sp-2-lnob-dashboard')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }